<style scoped>
    @import url("../../../styles/smartControl/cardReceita.scss");
</style>

<template>
    <div class="box_cardReceita mt-2">

        <!-- LOADING -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="linhaZero">
            <v-chip size="x-small" color="white">{{ recipe.formula }}</v-chip>
            <v-chip v-if="recipe.name==null" class="ml-1" size="x-small" color="white">Receita sem nome</v-chip>
            <v-chip v-else class="ml-1" size="x-small" color="white">{{ recipe.name }}</v-chip>
            <v-icon class="ml-1">mdi-note-edit</v-icon>
        </div>

        <div class="linhaUm">
            <div class="colUm">
                <span :style="{'color':'#F39C12'}">{{ 'idealEC: ' }}
                    <span :style="{'color':'white'}">{{ recipe.idealEC }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">{{ 'relMaxEC: ' }}
                    <span :style="{'color':'white'}">{{ recipe.relMaxEC }}</span>
                </span>
            </div>

            <div class="colUm">
                <span :style="{'color':'#F39C12'}">{{ 'ceAbsoluteAlarm: ' }}
                    <span :style="{'color':'white'}">{{ recipe.ceAbsoluteAlarm }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">{{ 'ECControl: ' }}
                    <span :style="{'color':'white'}">{{ recipe.ECControl }}</span>
                </span>
            </div>
            
            <div class="colDois">
                <span :style="{'color':'#F39C12'}">{{ 'idealPH: ' }}
                    <span :style="{'color':'white'}">{{ recipe.idealPH }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">{{ 'phAbsoluteAlarm: ' }}
                    <span :style="{'color':'white'}">{{ recipe.phAbsoluteAlarm }}</span>
                </span>
            </div>

            <div class="colDois">
                <span :style="{'color':'#F39C12'}">{{ 'phControl: ' }}
                    <span :style="{'color':'white'}">{{ recipe.phControl }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">{{ 'ideal_incremental: ' }}
                    <span :style="{'color':'white'}">{{ recipe.ideal_incremental }}</span>
                </span>
            </div>

            <div class="colDois">
                <span :style="{'color':'#F39C12'}">{{ 'fertilizer_0_percentage: ' }}
                    <span :style="{'color':'white'}">{{ recipe.fertilizer_0_percentage }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">{{ 'fertilizer_1_percentage: ' }}
                    <span :style="{'color':'white'}">{{ recipe.fertilizer_1_percentage }}</span>
                </span>
            </div>

            <div class="colDois">
                <span :style="{'color':'#F39C12'}">{{ 'fertilizer_2_percentage: ' }}
                    <span :style="{'color':'white'}">{{ recipe.fertilizer_2_percentage }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">{{ 'fertilizer_3_percentage: ' }}
                    <span :style="{'color':'white'}">{{ recipe.fertilizer_3_percentage }}</span>
                </span>
            </div>

            <div class="colDois">
                <span :style="{'color':'#F39C12'}">{{ 'fertilizer_4_percentage: ' }}
                    <span :style="{'color':'white'}">{{ recipe.fertilizer_4_percentage }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">{{ 'fertilizer_5_percentage: ' }}
                    <span :style="{'color':'white'}">{{ recipe.fertilizer_5_percentage }}</span>
                </span>
            </div>

            <div class="colDois">
                <span :style="{'color':'#F39C12'}">{{ 'fertilizer_6_percentage: ' }}
                    <span :style="{'color':'white'}">{{ recipe.fertilizer_6_percentage }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">{{ 'fertilizer_7_percentage: ' }}
                    <span :style="{'color':'white'}">{{ recipe.fertilizer_7_percentage }}</span>
                </span>
                <span :style="{'color':'#F39C12'}">{{ 'fertilizer_8_percentage: ' }}
                    <span :style="{'color':'white'}">{{ recipe.fertilizer_8_percentage }}</span>
                </span>
            </div>
        </div>
    
    </div>
</template>

<script>
export default {

    props:['recipe'],

    data() {
        return {
            // estrutural
            flagLoading:true,
        }
    },

    methods:{

        init() {
            this.flagLoading = true // fechar form
            
            this.flagLoading = false // abrir form
        },
    },

    created() { this.init() }
}
</script>
